import instance from "../../api";
import queryString from "querystring";

const adsApi = {
    getSales: () => {
        return instance().get(`/sales`).then(res => res.data)
    },
    getSalesForBranchGroup: (id, queryParams) => {
        return instance().get(`/branches/${id}/sales${queryParams ? `?${queryParams}` : ''}`).then(res => res.data)
    },
    getSaleById: (id) => {
        return instance().get(`/sales/${id}`).then(res => res.data)
    },
    getCustomersBySaleId: (id, params) => {
        const newParams = {};
        Object.keys(params).forEach((key) => {
            if (params[key] !== null && params[key] !== "") {
                newParams[key] = params[key];
            }
        })
        const prms = queryString.stringify(newParams, '&', '',{
            skipNull: true,
            skipEmptyString: true
        })

        return instance().get(`/sales/${id}/customers?${prms}`).then(res => res.data)
    },

    getCustomersBySale: (id) => {
        return instance().get(`/sales/${id}/customers`).then(res => res.data)
    },
    getBusinessCustomersBySale: (id) => {
        return instance().get(`/branches/${id}/sale/users`).then(res => res.data)
    },
    getSaleReport: (id, queryParams) => {
        return instance().get(`/sales/${id}/report${queryParams ? `?${queryParams}` : ''}`).then(res => res.data)
    },

    createSale: (data) => {
        return instance().post(`/sales`, data).then(res => res.data)
    },
    activateSale: (id) => {
        return instance().post(`/sales/${id}/activate`).then(res => res.data)
    },

    updateSale: (id, data) => {
        return instance().put(`/sales/${id}`, data).then(res => res.data)
    },
    updateSaleStatus: (id, data) => {
        return instance().put(`/sales/${id}/status`, data).then(res => res.data)
    },

    deleteSale: (id, data) => {
        return instance().delete(`/sales/${id}`, data).then(res => res.data)
    },

    compareAds: (id, queryParams, body) => {
        return instance().post(`/branches/${id}/sales/compare${queryParams ? `?${queryParams}` : ''}`, body).then(res => res.data)
    },
}

export default adsApi;
